// 정규식 활용한 유틸 모음
// 전화번호등
/* eslint-disable max-len */
// TODO : (기존 정규식 - 백업용) const PHONE_PATTERN = /^(\d{3})(\d{3,4})(\d{4})$/;
export const PHONE_PATTERN = /(^02.{0}|^01.{1}|^[0-9]{3})([0-9]*)([0-9]{4})/;
// 숫자 여부
export const NUMBER_REG_EXP = /^[0-9]+$/;
// 정수
export const INTEGER_REG_EXP = /^0|[-]?[1-9]\d*/;
// 전화번호 마스킹
export const MASKING_PHONE_NUMBER = /\d(?=\d{4})/g;
// 계좌번호
export const FORMAT_BANK_ACCOUNT = /^(\d{4})(\d{3})(\d+)$/;
// 유저 권한 분리
export const PERMISSION_PATTERN = /,|\//;
// 사업자등록번호
export const REG_BUSINESS_NUMBER = /^(\d{3})(\d{2})(\d{5})$/;
// 이메일 유효성 검사
// https://www.notion.so/barogohq/806c2bbff42240b5af0e3280230135ba?p=056c9e7a9c2945af8b5485f3aa16b33b&pm=s
export const EMAIL_PATTERN = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
// 비밀번호 유효성 (영문 대문자, 소문자, 숫자, 특수문자 중 2가지 이상의 조합)
export const PASSWORD_PATTERN = /^(?!((?:[A-Z]+)|(?:[a-z]+)|(?:[~!@#$%^&*()_+=]+)|(?:[0-9]+))$)[A-Za-z\d~!@#$%^&*()_+=]{10,}$/;
// 차량번호
// 1 / 2 / 3 패턴(1996 개정판~ ) 일치 여부
// - 1번째 패턴: 숫자2+한글1+숫자4
// (ex.12조1234)
const carNumberRegex1 = /^\d{2}[가|나|다|라|마|거|너|더|러|머|버|서|어|저|고|노|도|로|모|보|소|오|조|구|누|두|루|무|부|수|우|주|바|사|아|자|허|배|호|하]\d{4}$/;
// - 2번째 패턴: 한글2+숫자2+한글1+숫자4
//  (ex.서울12조1233)
const carNumberRegex2 = /^[서울|부산|대구|인천|대전|광주|울산|제주|경기|강원|충남|전남|전북|경남|경북|세종]{2}\d{2}[가|나|다|라|마|거|너|더|러|머|버|서|어|저|고|노|도|로|모|보|소|오|조|구|누|두|루|무|부|수|우|주|바|사|아|자|허|배|호|하]\d{4}$/;
// -  3번째 패턴: 숫자3+한글1+숫자4
//  (ex.01조1233)
const carNumberRegex3 = /^\d{3}[가|나|다|라|마|거|너|더|러|머|버|서|어|저|고|노|도|로|모|보|소|오|조|구|누|두|루|무|부|수|우|주|바|사|아|자|허|배|호|하]\d{4}$/;
export const CAR_NUMBER_PATTERN = [
    carNumberRegex1,
    carNumberRegex2,
    carNumberRegex3,
];
/**
 * 이메일 유효성 정규식
 * @ 기준 이전 글자는 영문자,숫자,언더바(_),점(.) 가능
 * @ 기준 이후에는 . 이 중간에 포함되어야 함
 * ex) barogo_email.2023@barogo.com
 */
export const EMAIL_REG_EXP = /^[A-Za-z0-9_\\.\\-]+@[A-Za-z0-9\\-]+\.[A-Za-z0-9\\-]+/;
/**
 * 소수점 정규식 생성
 * 두자리 + 소수점 자릿수 생성
 * 1, 1.1, 1.11, 11.1, 11.11등.. 인자로 소수점 자릿수 전달
 * @param decimalPlace {number} 소수점 자리수 전달
 * @returns
 */
export const makeRegExpPercentage = (decimalPlace) => {
    const point = [
        1,
    ];
    if (decimalPlace > 1) {
        point.push(decimalPlace);
    }
    return new RegExp(`^(\\d{1,2})(\\.{1}\\d{${point.join()}})?$`);
};
/**
 * 전화번호 패턴으로 변경
 * @param input
 * @returns
 */
export const formatPhoneNumber = (input = '') => {
    if (!input) {
        return '';
    }
    const matched = input.match(PHONE_PATTERN);
    if (matched) {
        return matched.slice(1).join('-');
    }
    return input;
};
/**
 * 전화번호 패턴 제거
 * @param _input
 * @returns
 */
export const formatPhoneNumberReverse = (_input = '') => {
    let input = _input;
    if (!input) {
        input = '';
    }
    return input.replace(/-/g, '');
};
export const isValidPhone = (input) => PHONE_PATTERN.test(input);
